import { forwardRef, Ref, SVGAttributes } from 'react'

type Props = SVGAttributes<SVGSVGElement>

const VideoPlay = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => (
  <svg
    ref={ref}
    width="20"
    height="22"
    viewBox="0 0 30 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29.151 15.9991C29.164 16.9651 28.9159 17.9166 28.4328 18.7532C27.9498 19.5899 27.2498 20.2805 26.4068 20.7522L8.2332 31.2447C7.40318 31.739 6.45504 32 5.48896 32C4.52288 32 3.57474 31.739 2.74473 31.2447C1.90165 30.773 1.20162 30.0824 0.71859 29.2457C0.235558 28.4091 -0.0125454 27.4575 0.000488304 26.4916V5.50666C-0.0122339 4.54098 0.236017 3.58978 0.719034 2.75348C1.20205 1.91718 1.90191 1.22681 2.74473 0.755261C3.57475 0.260943 4.52289 0 5.48896 0C6.45504 0 7.40317 0.260943 8.2332 0.755261L26.4068 11.246C27.2498 11.7177 27.9498 12.4084 28.4328 13.245C28.9159 14.0816 29.164 15.0331 29.151 15.9991Z"
      fill="#0F8040"
    />
  </svg>
))

export default VideoPlay
